import { render, staticRenderFns } from "./zykjyrDetail.vue?vue&type=template&id=4631824c&scoped=true&"
import script from "./zykjyrDetail.vue?vue&type=script&lang=js&"
export * from "./zykjyrDetail.vue?vue&type=script&lang=js&"
import style0 from "./zykjyrDetail.vue?vue&type=style&index=0&id=4631824c&lang=less&scoped=true&"
import style1 from "./zykjyrDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631824c",
  null
  
)

export default component.exports